import { useQueryClient } from 'react-query';
import {
  useGetInstanceTypeLayers,
  useUpdateInstanceTypeLayer,
  useCreateInstanceTypeLayer,
  useDeleteInstanceTypeLayer,
  useGetLayerFunctions,
} from '../../hooks/api';
import { LayerOperationsContext } from '../../../../../components/compositionLayersTable/LayerOperationsContext';
import CompositionLayersTable from '../../../../../components/compositionLayersTable/CompositionLayersTable';

type TyperMarkCompositionLayersTableProps = {
  instanceTypeId: string;
};

const TyperMarkCompositionLayersTable = ({
  instanceTypeId,
}: TyperMarkCompositionLayersTableProps) => {
  const queryClient = useQueryClient();

  const { data: layers = [], isLoading, error } = useGetInstanceTypeLayers(instanceTypeId);
  const { data: layerFunctions = [], isLoading: isLoadingFunctions } = useGetLayerFunctions();
  const { mutate: createLayer, isLoading: isCreating } = useCreateInstanceTypeLayer();
  const {
    mutate: updateLayer,
    mutateAsync: updateLayerAsync,
    isLoading: isUpdating,
  } = useUpdateInstanceTypeLayer();
  const { mutate: deleteLayer, isLoading: isDeleting } = useDeleteInstanceTypeLayer();

  const handleSuccess = () => {
    queryClient.invalidateQueries(['instance-type-layers', instanceTypeId]);
  };

  return (
    <LayerOperationsContext.Provider
      value={{
        entityId: instanceTypeId,
        layers,
        isLoading,
        error,
        createLayer,
        updateLayer,
        updateLayerAsync,
        deleteLayer,
        isCreating,
        isUpdating,
        isDeleting,
        layerFunctions,
        isLoadingFunctions,
        onSuccess: handleSuccess,
      }}
    >
      <CompositionLayersTable />
    </LayerOperationsContext.Provider>
  );
};

export default TyperMarkCompositionLayersTable;
